const API_BASE_URL = '/api';

export async function printTicket(
  rsTicketId: number,
  signal?: AbortSignal,
): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/tickets/${rsTicketId}/print`, {
    method: 'POST',
    signal,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => null);
    throw new Error(err?.error ?? `Failed to print ticket: ${response.status}`);
  }
}
